import { useTopMarquee } from '@cannect/contexts/TopMarqueeContext'
import CartSheet from '@cannect/new-components/CartSheet'
import { Button, Icons, Link } from '@cannect/new-components/atoms'
import { useBrand } from 'hooks/useBrand'
import { useEffect, useState } from 'react'
import { LuMenu } from 'react-icons/lu'
import { useHistory, useLocation } from 'react-router-dom'
import { getBrandHeaderLogo } from './brandLogo'
import { MobileMenuSheet } from './MobileMenuSheet'
import { useHeader } from './useHeader'

import { CounterBadge } from '@cannect/new-components/molecules'

export const HeaderMobile = ({
  menuConfig,
  signedUserName,
  handleLogout,
  isLogged,
  cartProductsQuantity,
  isLoadingCartQuantity,
  isPublicFlow
}: ReturnType<typeof useHeader>) => {
  const [isCartSheetOpen, setIsCartSheetOpen] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { setMenuOpen } = useTopMarquee()
  const { config } = useBrand()
  const headerForeground = config.headerForeground ?? '#FFFFFF'
  const history = useHistory()
  const { pathname } = useLocation()
  const isSameRouteHome = pathname === config.routes.home

  const handleCartClick = () => {
    history.push('/AreaAssociados/MinhaConta?pagina=carrinho')
  }

  const handleMenuToggle = () => {
    const newMenuState = !isMenuOpen
    setIsMenuOpen(newMenuState)
    setMenuOpen(newMenuState)
  }

  useEffect(() => {
    setMenuOpen(isMenuOpen)
  }, [isMenuOpen, setMenuOpen])

  return (
    <>
      <div
        className="container w-full py-4"
        style={{ backgroundColor: config.headerBackground ?? config.colors.primary }}>
        <div
          className={`flex items-center gap-4 ${
            // Vikura/Remederi: jornada guiada sem sacola nem menu — logo centralizada
            config.key === 'vikura' || config.key === 'remederi' ? 'justify-center' : 'justify-between'
          }`}>
          {/* Vikura/Remederi: home aponta para a própria página de agendamento —
              navegação client-side não remonta o componente (mesma rota) e
              deixa o formulário com estado antigo. isExternal força reload. */}
          <Link to={config.routes.home} isExternal={isSameRouteHome}>
            <img src={getBrandHeaderLogo(config.key)} alt={`Logo ${config.name}`} className="w-36 object-contain" />
          </Link>

          {/* Vikura/Remederi: jornada guiada sem sacola nem menu no mobile */}
          {config.key !== 'vikura' && config.key !== 'remederi' && (
            <div className="flex items-center gap-3">
              {!isPublicFlow && (
                <button
                  onClick={handleCartClick}
                  className="relative flex items-center justify-center border-none bg-transparent p-1">
                  <Icons.ShoppingBag className="h-6 w-6" style={{ color: headerForeground }} />
                  <CounterBadge quantity={cartProductsQuantity} isLoading={isLoadingCartQuantity} />
                  <span className="sr-only">Carrinho</span>
                </button>
              )}

              <Button unstyled onClick={handleMenuToggle}>
                <LuMenu className="!h-6 !w-6" style={{ color: headerForeground }} />
                <span className="sr-only">Toggle navigation menu</span>
              </Button>
            </div>
          )}
        </div>
      </div>

      <CartSheet isOpen={isCartSheetOpen} onClose={() => setIsCartSheetOpen(false)} />

      <MobileMenuSheet
        isOpen={isMenuOpen}
        onClose={() => {
          setIsMenuOpen(false)
          setMenuOpen(false)
        }}
        menuConfig={menuConfig}
        signedUserName={signedUserName}
        isLogged={isLogged}
        handleLogout={handleLogout}
      />
    </>
  )
}
